import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aecda394"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "help-edit-modal" }
const _hoisted_2 = { class: "modal-mask" }
const _hoisted_3 = { class: "modal-wrapper" }
const _hoisted_4 = { class: "button-bar" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "help-page-title ml-4",
  style: {"color":"white"}
}
const _hoisted_7 = {
  key: 1,
  class: "help-page-title ml-4",
  style: {"color":"white"}
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", {
  class: "help-page-title ml-4",
  style: {"color":"white"}
}, "Edit Popovers", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "preview" }
const _hoisted_12 = { class: "modal-header mt-4" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_14 = {
  class: "ql-container ql-snow ql-disabled",
  style: {"width":"100%","border":"none"}
}
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Internal Note", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"Arial, Helvetica, sans-serif","color":"var(--ls-slate-light)"} }, "For internal use only", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_21 = {
  key: 0,
  class: "popover-preview mt-4 mb-3"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "popover-preview-text" }, "Hover Icon to Preview", -1))
const _hoisted_23 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { class: "input-box" }
const _hoisted_26 = { key: 3 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Help Content *", -1))
const _hoisted_29 = { style: {"width":"100%"} }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "notes mt-4 mb-4",
  style: {"display":"flex","align-items":"center"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle mr-3" }),
  /*#__PURE__*/_createElementVNode("div", null, "Prior to saving, we highly recommend previewing your changes by clicking the \"Show Preview\" toggle above.")
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "notes mt-4 mb-4",
  style: {"display":"flex","align-items":"center"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle mr-3" }),
  /*#__PURE__*/_createElementVNode("div", null, "Please note that your changes will take effect automatically on newly login user once you initiate the saving process. ")
], -1))
const _hoisted_33 = { key: 4 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Popover Content *", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "notes",
  style: {"display":"flex","align-items":"center"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle mr-3" }),
  /*#__PURE__*/_createElementVNode("div", { style: {"color":"var(--ls-error-red)"} }, "Only use normal font, bold, italics, underline, and URLs. ")
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "notes mt-4 mb-4",
  style: {"display":"flex","align-items":"center"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle mr-3" }),
  /*#__PURE__*/_createElementVNode("div", null, "Prior to saving, we highly recommend reviewing your changes by hovering over the icon above.")
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "notes mt-4 mb-4",
  style: {"display":"flex","align-items":"center"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle mr-3" }),
  /*#__PURE__*/_createElementVNode("div", null, "Please note that your changes will take effect automatically on newly login user once you initiate the saving process. ")
], -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_41 = { class: "help-edit-footer" }
const _hoisted_42 = { key: 5 }

export function render(_ctx, _cache) {
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")
  const _component_Popover = _resolveComponent("Popover")
  const _component_QuillEditor = _resolveComponent("QuillEditor")
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["modal-container", [{'is-closing' : _ctx.isClosing} ]])
            }, [
              _createElementVNode("div", _hoisted_4, [
                (!_ctx.isPopover)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (!_ctx.isPreviewing)
                        ? (_openBlock(), _createElementBlock("h4", _hoisted_6, "Edit Help"))
                        : (_openBlock(), _createElementBlock("h4", _hoisted_7, "Preview Help Only")),
                      _createVNode(_component_ToggleSwitch, {
                        class: "toggle-switch",
                        initState: _ctx.isPreviewing,
                        "onUpdate:initState": _cache[0] || (_cache[0] = $event => ((_ctx.isPreviewing) = $event)),
                        activeText: "Edit Help",
                        inactiveText: "Show Preview",
                        disabled: false
                      }, null, 8, ["initState"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isPopover)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.tempHelpContent.title), 1)
                ]),
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", {
                    class: "ql-editor ql-blank",
                    "data-gramm": "false",
                    contenteditable: "false",
                    style: {"padding":"0 0"},
                    innerHTML: _ctx.tempHelpContent.content
                  }, null, 8, _hoisted_15)
                ])
              ], 512), [
                [_vShow, _ctx.isPreviewing]
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _hoisted_16,
                _hoisted_17,
                _hoisted_18,
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.tempHelpContent.internalNote) = $event)),
                  rows: "4",
                  cols: "50",
                  placeholder: "Enter note (5000 characters limit)"
                }, null, 512), [
                  [_vModelText, _ctx.tempHelpContent.internalNote]
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["footnote", [_ctx.tempHelpContent.internalNote?.length === 5000 ? 'full' : '']])
                }, _toDisplayString(_ctx.tempHelpContent.internalNote?.length || 0) + "/5000 characters ", 3),
                _hoisted_19,
                _hoisted_20,
                (_ctx.isPopover)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("span", null, [
                        _createVNode(_component_Popover, {
                          popover: _ctx.tempHelpContent,
                          preview: true
                        }, null, 8, ["popover"])
                      ]),
                      _hoisted_22
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isPopover)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_23, "Help Title *"))
                  : (_openBlock(), _createElementBlock("h4", _hoisted_24, "Popover Title *")),
                _createElementVNode("div", _hoisted_25, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.tempHelpContent.title) = $event)),
                    placeholder: "Enter title (100 characters limit)",
                    style: {"width":"100%"},
                    maxlength: "100"
                  }, null, 512), [
                    [_vModelText, _ctx.tempHelpContent.title]
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["footnote", [_ctx.tempHelpContent.title?.length === 100 ? 'full' : '']])
                  }, _toDisplayString(_ctx.tempHelpContent.title?.length || 0) + "/100 characters ", 3)
                ]),
                (!_ctx.isPopover)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _hoisted_27,
                      _hoisted_28,
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_QuillEditor, {
                          ref: "quillEditor",
                          style: {"min-height":"350px","height":"calc(100vh - 800px)","width":"100%"},
                          theme: "snow",
                          onTextChange: _ctx.checkNote,
                          toolbar: _ctx.toolbarOptions,
                          content: _ctx.tempHelpContent.content,
                          "onUpdate:content": _cache[3] || (_cache[3] = $event => ((_ctx.tempHelpContent.content) = $event)),
                          contentType: "html"
                        }, null, 8, ["onTextChange", "toolbar", "content"])
                      ]),
                      _hoisted_30,
                      _hoisted_31,
                      _hoisted_32
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _hoisted_34,
                      _hoisted_35,
                      _hoisted_36,
                      _createElementVNode("div", null, [
                        _createVNode(_component_QuillEditor, {
                          ref: "quillEditor",
                          style: {"width":"100%"},
                          theme: "snow",
                          onTextChange: _ctx.checkNote,
                          toolbar: _ctx.toolbarPopovers,
                          content: _ctx.tempHelpContent.content,
                          "onUpdate:content": _cache[4] || (_cache[4] = $event => ((_ctx.tempHelpContent.content) = $event)),
                          contentType: "html"
                        }, null, 8, ["onTextChange", "toolbar", "content"])
                      ]),
                      _hoisted_37,
                      _hoisted_38,
                      _hoisted_39
                    ])),
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, [
                  (_ctx.isSaving)
                    ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                        key: 0,
                        loadingText: "Saving... ",
                        class: "mr-4"
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.close && _ctx.close(...args))),
                    class: "btn btn-outline mr-2"
                  }, "Cancel"),
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[6] || (_cache[6] = (...args) => (_ctx.saveContent && _ctx.saveContent(...args)))
                  }, "Save")
                ]),
                (_ctx.isTesting)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(_ctx.tempHelpContent.pageId) + ", " + _toDisplayString(_ctx.tempHelpContent.key), 1))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vShow, !_ctx.isPreviewing]
              ])
            ], 2)
          ])
        ])
      ]),
      _: 1
    })
  ]))
}